import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../styles/Skills.css';

gsap.registerPlugin(ScrollTrigger);

const Skills = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const skillsRef = useRef(null);

  const skills = [
    { name: 'Python', level: 100, icon: '🐍' },
    { name: 'Frappe / ERPNext', level: 100, icon: '📦' },
    { name: 'Git', level: 100, icon: '🔧' },
    { name: 'React.js', level: 90, icon: '⚛️' },
    { name: 'JavaScript', level: 90, icon: '💻' },
    { name: 'Software Architecture & Design', level: 90, icon: '🏗️' },
    { name: 'MySQL', level: 90, icon: '🗄️' },
    { name: 'CSS / Sass', level: 75, icon: '🎨' },
    { name: 'MongoDB', level: 70, icon: '🍃' },
    { name: 'DevOps', level: 65, icon: '🚀' },
  ];

  useEffect(() => {
    const ctx = gsap.context(() => {
      const section = sectionRef.current;
      const title = titleRef.current;
      const skillElements = skillsRef.current?.children ?? [];

      gsap.from(title, {
        scrollTrigger: {
          trigger: section,
          start: 'top 75%',
          toggleActions: 'play none none none'
        },
        y: 60,
        scale: 0.95,
        duration: 1,
        ease: 'power3.out',
        clearProps: 'transform,opacity'
      });

      Array.from(skillElements).forEach((skill, index) => {
        const progressBar = skill.querySelector('.skill-progress-fill');
        const level = skills[index].level;

        // gsap.from(skill, {
        //   scrollTrigger: {
        //     trigger: skill,
        //     start: 'top 85%',
        //     toggleActions: 'play none none reverse'
        //   },
        //   x: -80,
        //   scale: 0.95,
        //   duration: 0.7,
        //   delay: index * 0.08,
        //   ease: 'power3.out'
        // });

        if (progressBar) {
          gsap.fromTo(
            progressBar,
            { width: '0%' },
            {
              scrollTrigger: {
                trigger: skill,
                start: 'top 85%',
                toggleActions: 'play none none reverse'
              },
              width: `${level}%`,
              duration: 1.2,
              ease: 'power3.out'
            }
          );
        }
      });
    }, sectionRef);

    return () => ctx.revert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section ref={sectionRef} className="skills" id="skills">
      <div className="skills-container">
        <h2 ref={titleRef} className="skills-title">Skills & Expertise</h2>
        
        <div ref={skillsRef} className="skills-list">
          {skills.map((skill, index) => (
            <div key={index} className="skill-item">
              <div className="skill-header">
                <span className="skill-icon">{skill.icon}</span>
                <span className="skill-name">{skill.name}</span>
                <span className="skill-level">{skill.level}%</span>
              </div>
              <div className="skill-progress">
                <div 
                  className="skill-progress-fill" 
                  style={{ width: `${skill.level}%` }}
                >
                  <div className="progress-glow"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="tools-section">
          <h3 className="tools-title">Technologies & Tools</h3>
          <div className="tools-grid">
            <div className="tool-category">
              <h4>Frontend</h4>
              <p>React.js, Vue.js, HTML5, CSS3, JavaScript</p>
            </div>
            <div className="tool-category">
              <h4>Backend</h4>
              <p>Frappe, Django, Flask</p>
            </div>
            <div className="tool-category">
              <h4>Database</h4>
              <p>MariaDB, MongoDB, PostgreSQL, Firebase</p>
            </div>
            <div className="tool-category">
              <h4>DevOps</h4>
              <p>Docker, CI/CD, GitHub Actions, Vercel</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
